// eslint-disable-next-line camelcase
export default class detailIF4IF_LicenseInvoices {
    load(sAction, data) {
        // call immediately after detailView is load

        if (!sAction.dataGet(data.prefix + '/fields/id/value')) {
            data.value = {};
            data.value.id = sAction.dataGet(data.prefix + '/fields/if4if_licenses_if4if_licenseinvoices_1_name/def/id_value');
            data.value.name = sAction.dataGet(data.prefix + '/fields/if4if_licenses_if4if_licenseinvoices_1_name/value');
            this.loadLicenseData(sAction, data);
        }

        if (sAction.dataGet(data.prefix + '/customData/customLines/lines')?.some((line) => ![1, '1'].includes(line.get('deleted')))) {
            sAction.dataSet(data.prefix + '/fields/invoice_amount/def/readonly', true);
        }

        this.setLinesModelsFilter(
            sAction,
            data.prefix,
            sAction.dataGet(data.prefix + '/fields/if4if_licenses_if4if_licenseinvoices_1if4if_licenses_ida/value'),
        );
    }
    update(sAction, data) {
        switch (data.field) {
            case 'if4if_licenses_if4if_licenseinvoices_1if4if_licenses_ida':
                this.loadLicenseData(sAction, data);
                this.setLinesModelsFilter(sAction, data.prefix, data.value.id);
                break;
            case 'invoice_amount':
            case 'currency_id': {
                const price = data.field === 'invoice_amount' ? data.value : sAction.dataGet(data.prefix + '/fields/invoice_amount/value');
                const currency = data.field === 'currency_id' ? data.value : sAction.dataGet(data.prefix + '/fields/currency_id/value');
                const rate = sAction.currencies[currency].conversion_rate;
                const priceUSD = price/rate;
                const productValue = sAction.dataGet(data.prefix + '/fields/value/value');
                const total = (parseFloat(priceUSD) || 0) + (parseFloat(productValue) || 0);

                sAction.dsClear();
                sAction.dsAdd('set', data.prefix + '/fields/exchange_rate/value', rate);
                sAction.dsAdd('set', data.prefix + '/changes/fields/exchange_rate', rate);

                sAction.dsAdd('set', data.prefix + '/fields/amount_usd/value', priceUSD);
                sAction.dsAdd('set', data.prefix + '/changes/fields/amount_usd', priceUSD);

                sAction.dsAdd('set', data.prefix + '/fields/total/value', total);
                sAction.dsAdd('set', data.prefix + '/changes/fields/total', total);
                sAction.dsProcess();
                break;
            }
            case 'value': {
                const totalValue = sAction.dataGet(data.prefix + '/fields/amount_usd/value');
                const total = (parseFloat(data.value) || 0) + (parseFloat(totalValue) || 0);
                sAction.dsClear();
                sAction.dsAdd('set', data.prefix + '/fields/total/value', total);
                sAction.dsAdd('set', data.prefix + '/changes/fields/total', total);
                sAction.dsProcess();
                break;
            }
        }
        // call immediately after detailView field is update
    }
    newSubRecord(sAction, data) {
        // call immediately before route sub record
    }
    beforeSave(sAction, data) {
        // call bfore Record is save

        return true;
    }
    updateDetailLine(sAction, data) {
        switch (data.field) {
            case 'amount':
            case 'deleted': {
                const linePrefix = data.prefix.substring(0, data.prefix.lastIndexOf('/'));
                const total = sAction.dataGet(linePrefix).reduce((total, current) => {
                    if ([1, '1'].includes(current.get('deleted'))) return total;
                    return total +parseFloat(current.get('amount') || 0);
                }, 0);

                const prefix = linePrefix.substring(0, linePrefix.indexOf('/customData/'));
                sAction.dsClear();
                sAction.dsAdd('set', prefix + '/fields/invoice_amount/value', total);
                sAction.dsAdd('set', prefix + '/changes/fields/invoice_amount', total);
                sAction.dsAdd('set', prefix + '/fields/invoice_amount/def/readonly', true);
                sAction.dsProcess();

                this.update(sAction, {field: 'invoice_amount', prefix: prefix, value: total});
                break;
            }
            case 'aon_list_of_models_aon_license_invoice_products_1_name':
            case 'product': {
                const product = data.field === 'product' ? data.value : sAction.dataGet(`${data.prefix}/product`);
                const productName = sAction.translateEnum('product_solutions_enum', product);
                const modelName = data.field === 'aon_list_of_models_aon_license_invoice_products_1_name' ?
                    data.value.name :
                    sAction.dataGet(data.prefix + '/fields/aon_list_of_models_aon_license_invoice_products_1_name/value');

                let name;
                if (product && modelName) {
                    name = `${productName} – ${modelName}`;
                } else if (product) {
                    name = productName;
                } else if (modelName) {
                    name = modelName;
                }
                if (name) {
                    sAction.dataSet(`${data.prefix}/name`, name);
                }
                break;
            }
        }
    }

    loadLicenseData(sAction, data) {
        if (!data.value.id) {
            return;
        }

        const fields = {
            name: 'name',
            accounts_if4if_licenses_1accounts_ida: 'accounts_if4if_licenseinvoices_1accounts_ida',
            accounts_if4if_licenses_1_name: 'accounts_if4if_licenseinvoices_1_name',
            if4if_contracts_if4if_licenses_1if4if_contracts_ida: 'if4if_contracts_if4if_licenseinvoices_1if4if_contracts_ida',
            if4if_contracts_if4if_licenses_1_name: 'if4if_contracts_if4if_licenseinvoices_1_name',
            percent_increase_per_year: 'percent_increase_per_year',
            payment_type: 'payment_type',
            grids_code: 'grids_code',
            expected_billing_period: 'billing_month',
        };

        const sendData = {
            module: 'IF4IF_Licenses',
            id: data.value.id,
            fields: Object.keys(fields),
            action: 'getBeanInfo',
        };

        sAction.load();
        sAction.rest.fetchData('customAction', 'POST', sendData, false).then((response) => {
            sAction.dsClear();
            for (const [key, value] of Object.entries(response)) {
                if (key === 'name') {
                    sAction.dsAdd('set', data.prefix + '/fields/' + fields[key] + '/value', `${value} – invoice`);
                    sAction.dsAdd('set', data.prefix + '/changes/fields/' + fields[key], `${value} – invoice`);
                    continue;
                }
                sAction.dsAdd('set', data.prefix + '/fields/' + fields[key] + '/value', value);
                sAction.dsAdd('set', data.prefix + '/changes/fields/' + fields[key], value);
            }

            sAction.dsProcess();
            sAction.unLoad();
        });
    }

    setLinesModelsFilter(sAction, prefix, licenseId) {
        if (!licenseId) {
            sAction.dataDelete(
                `${prefix}/customData/customLines/def/defaultFilter`,
                'aon_list_of_models_aon_license_invoice_products_1_name',
            );
            return;
        }

        sAction.rest.fetchData(`getLicensedModels/${licenseId}`, 'GET', null, false).then(({data}) => {
            sAction.dataSet(
                `${prefix}/customData/customLines/def/defaultFilter/aon_list_of_models_aon_license_invoice_products_1_name/id`,
                {
                    field: 'id',
                    value: data,
                    type: 'contArray',
                },
            );
        }).catch(() => {
            sAction.dataDelete(
                `${prefix}/customData/customLines/def/defaultFilter`,
                'aon_list_of_models_aon_license_invoice_products_1_name',
            );
        });
    }
}
